module.exports = __webpack_public_path__ + "img/logo-bbb.79a13252.png";